import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { CellRendererRouterLinkCustomParams } from '../models';

@Component({
  selector: 'grid-ui-cell-renderer-router-link',
  templateUrl: './cell-renderer-router-link.component.html',
  styleUrls: ['./cell-renderer-router-link.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class CellRendererRouterLinkComponent implements ICellRendererAngularComp {
  private readonly router = inject(Router);

  protected label = '';
  protected link: string[] = [];

  public agInit({ value: { label, link } }: CellRendererRouterLinkCustomParams): void {
    this.label = label;
    this.link = link;
  }

  public refresh(): boolean {
    return false;
  }

  public async navigate(): Promise<void> {
    await this.router.navigate(this.link);
  }
}
